import React, { useState } from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../common/VideoPlayerModal';

const VRHealthCare = () => {
    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }
  return (
    <>
    
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container pt-4 pt-md-5'>
            <Card.Body>
                <Card.Title className='industrial-modeling-title'>VR for Healthcare</Card.Title>
                <Card.Text className='industrial-environment-text'>
                As founding members of the International VR for Healthcare Association, we have many clients in the healthcare field. VR applications for healthcare range from surgery training, which would be unethical on health patients, to behavioral and physical therapies that are now going through clinical trials to prove their efficacy. 
                <br /> <br />Some surgeons complete certain operations rarely, and no patient wants to be the “refresher” patient as a surgeon remembers his previous training. VR simulation can help surgeons safely practice rare procedures and refresh their memories before operating on live humans.
                </Card.Text>
            </Card.Body>
            <Row className='pt-md-5'>
                <Col xs={{span:12, offset:0}} md={{span:5, offset:0}}>
                    <Card.Title className='vr-healthcare-title'>VR Surgery Training</Card.Title>
                    <Card.Text className='text-left vr-healthcare-text'>
                    For a surgeon entrepreneur, we created a VR simulation of laparoscopic cholecystectomy (a.k.a gallbladder removal), using a mix of physics and animations.
                    </Card.Text>
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:7, offset:0}}>
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('assets/vr-development/healthcare/video/Surgery.mp4')}>
                        <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/healthcare/images/health-care-banner.jpg"} />
                        <Card.ImgOverlay className='playicon-overlay-center'>
                            <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                        </Card.ImgOverlay>

                    </Card>
                    {/* <div className='container'>
                        <video className='container' preload="auto" controls playsInline>
                            <source src={process.env.PUBLIC_URL + "assets/industrial/video/ARM_Factory_Render_v001.mp4"} type="video/mp4"/>
                        </video>
                    </div> */}
                </Col>
                </Row>
                <Row className='px-md-4'>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/healthcare/images/001.jpg"} />
                </Col>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/healthcare/images/002.jpg"} />
                </Col>
                <Col xs={{span:4, offset:0}} className="no-padding-x pt-md-4">
                    <Card.Img className='img img-thumbnail' src={process.env.PUBLIC_URL + "assets/vr-development/healthcare/images/003.jpg"} />
                </Col>
            </Row>
        </Card>
        <VideoPlayerModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videosrc={videoUrl}
      />
    </>
  )
}

export default VRHealthCare
